import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './ayalonSW'

import vuetify from './plugins/vuetify';

import Service from "./service/service";
import Notification from "./components/Notification";
import offlineStorage from "./dbService";
import i18n from './i18n'
import vueCron from 'vue-crontab'
import Logger from "./service/logger";
import ayalconfig from "./ayalconfig";
import webLog from "./websql/weblog";

Vue.config.productionTip = false;

const service = new Service();
const logger = new Logger()
webLog.initLog();
Vue.prototype.$service = service;
Vue.prototype.$logger = logger;
// Vue.use(VueOffline,{mixin: false, storage:true});
Vue.use(vueCron);
new Vue({
  router,
  store,
  vuetify,

  created () {
    this.$vuetify.rtl = true;
    //this.initJobs();
    if(ayalconfig.logger.enableLog){
      vueCron.addJob({
        name: 'logger',
        interval: ayalconfig.logger.interval,
        job: this.startJobForLogger
      })
    }
  },
  i18n,
  components:{
    Notification: Notification
  },
  methods:{
    startJobForLogger(){
      if (navigator.onLine){
        webLog.select();
      }
      // offlineStorage.getItem('logs').then((logs)=>{
      //   if(logs && logs.createSyncEvent){
      //     navigator.serviceWorker.ready.then(function (registerSW) {
      //       registerSW.sync.register('loggerSync');
      //     }).then(function (val) {
      //       logs.createSyncEvent = false;
      //       console.log("This callback is triggered after looggerSync");
      //     })
      //   }
      // })
    }
  },
  render: h => h(App)
}).$mount('#app');
